angular.module('unergie.main')
.directive('salesTunnelClosing', ($q, $state, MetaWatcher, ApiUser, ErrorCatcher, AlertManager, AuthService, AdminComments) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        prm: '=',
        landscape: '=',
        readings: '=',
        user: '=',
        checks: '=',
        validated: '=',
        validation: '=',
        shootDraftMessage: '=',
        draftServices: '=',
        draftState: '=',
        disableContractEdition: '=',
    },
    templateUrl: '/states/salesTunnelV2/component/salesTunnelClosing.html',
    link($scope) {
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.saveUser = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_USER')
        $scope.saveChecks = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_CHECKS')
        $scope.saveDraftState = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT_STATE')
        $scope.saveContractEventMsg = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.CONTRACT_EVENT_MSG')

        // CHECKOUT
        $scope.shootDraftFields = {}
        $scope.shootDraftButtons = {}

        $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])

        $scope.selfReportable = () => {
            const reportBase = !!($scope.plan_id === 10 && $scope.switchReadings.base)
            const reportHPHC = !!($scope.plan_id === 20 && $scope.switchReadings.hc && $scope.switchReadings.hp)
            return reportBase || reportHPHC
        }

        $scope.readyToShoot = () => !$scope.checks.transformed && $scope.validated.all

        $scope.prepareShootDraft = function (vendorSignature) {
            $scope.shootDraftFields = {
                overdue: {
                    type: 'label',
                    label: '<i class="fa fa-spinner fa-spin fa-fw"></i>&nbsp;Vérification en cours...',
                },
            }
            $scope.shootDraftButtons = {}
            return $scope.draftServices.linkDraftToUser().then(() => {
                return ApiUser.refreshDraftOverdue({ idDraft: $scope.draft.id }).$promise
            }).then((overdueScoring) => {
                $scope.shootDraftFields = {}
                if (overdueScoring.overdue_check === true) {
                    $scope.shootDraftFields = {
                        overdue: {
                            type: 'label',
                            label: 'Un dépôt de garantie va être demandé',
                        },
                    }
                    $scope.shootDraftButtons = {
                        cancelDraft: {
                            label: 'Annuler la vente',
                            execute() {
                                const comment = `<b>AUTOMATIQUE</b> : Dépôt de garantie demandé (score = ${overdueScoring.score}) <strong>➡ vente abandonnée</strong>`
                                AdminComments.addComment({ object: $scope.draft.customer_id, comment }).$promise.catch(ErrorCatcher)
                                $state.go('salesTunnelV2')
                            },
                        },
                    }
                }
                $scope.shootDraftButtons.submitDraft = {
                    label: vendorSignature ?
                        `Signer&nbsp;<i class="fa fa-pencil"></i>` :
                        `${$scope.draft.checkout_mail_sent ? 'Renvoyer' : 'Envoyer'}&nbsp;<i class="fa fa-envelope-o"></i>`,
                    execute() {
                        if (vendorSignature) {
                            $scope.signForClient()
                        } else {
                            $scope.shootDraft()
                        }
                    },
                }
            })
            .catch((error) => {
                ErrorCatcher(error)
                $scope.shootDraftFields = {}
            })
        }

        $scope.shootDraft = () => {
            $scope.draftServices.shootDraft()
        }

        $scope.signForClient = () => {
            $scope.draftServices.signForClient()
        }
    },
}))
